<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->
<ngf-input-container
  [hasError]="hasError"
  [hasShadow]="hasShadow"
  [infixOverflowHidden]="!hideInput"
  [class.disabled]="disabled"
  [class.hide-input]="hideInput">

  <!-- Single root only, or the content lands in the default slot instead of [ngfPrefix] / [ngfSuffix]. Flush braces are style, not need. -->
  @if (prefixIcon) {<mat-icon ngfPrefix>{{prefixIcon}}</mat-icon>}

  <!--suppress HtmlFormInputWithoutLabel -->
  <input #selectInput [placeholder]="placeholder" [value]="displayValue" readonly (blur)="handleBlur()"
         [attr.disabled]="disabled ? '' : null" [attr.aria-required]="select?.isRequired || null" [attr.aria-label]="ariaLabel"
         [attr.aria-labelledby]="ariaLabelledby" [attr.aria-describedby]="effectiveAriaDescribedby" role="combobox"
         aria-haspopup="listbox" aria-readonly="true" [attr.aria-expanded]="isOpen" aria-controls="options-container" ngfOverflow="ellipsis"
         [ngfOverflowTooltip]="selectInput.value" [ngfOverflowTooltipOnFocus]="false" [ngfOverflowTooltipDisabled]="!showOverflowTooltip">
  @if (ariaValueDescription) {
    <span [id]="descId" class="value-desc">{{ariaValueDescription}}</span>
  }
  <ng-content />
  @if (showClear) {<button ngfSuffix
          type="button"
          class="clear-icon"
          aria-label="Clear selection"
          (click)="handleClearClick($event)">
    <mat-icon inline>clear</mat-icon>
  </button>}

  <span ngfSuffix class="toggle-icon">
    <mat-icon inline>{{isOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
  </span>
</ngf-input-container>
